module.exports = "<div ng-click=\"$ctrl.openFeedbackModal()\" class=\"serp-feedback-trigger\"><div class=\"c-icon serp-feedback-trigger__icon\"></div><div class=\"serp-feedback-trigger__text\"><ng-transclude></ng-transclude></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/feedback/template.jade
// module id = 929
// module chunks = 0